import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-end pt-20 pb-32">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/23d84010c3673d0d90deaf2f0c6239ed.jpeg"
          alt="LaTonya Duncan - Founder"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <h1 className="font-serif text-5xl lg:text-6xl font-bold text-white leading-tight drop-shadow-lg">
              Empowering Lives.<br />
              <span className="text-coral">Transforming Communities.</span>
            </h1>
            
            <p className="text-lg text-white/90 leading-relaxed max-w-xl drop-shadow-md">
              Founded by two-time stroke survivor LaTonya Duncan, 1 Heart Health and Wellness empowers communities through education on heart health, mental wellness, breast cancer awareness, domestic violence prevention, and HIV awareness. Because knowledge saves lives.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Link
                to="/programs"
                className="bg-coral text-white px-8 py-3.5 rounded-full font-semibold hover:bg-coral/90 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-sm"
              >
                Explore Our Programs
              </Link>
              <Link
                to="/about"
                className="bg-charcoal text-white px-8 py-3.5 rounded-full font-semibold hover:bg-charcoal/90 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-sm"
              >
                Learn My Story
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
